/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=7d9e4f6c&scoped=true&lang=html&"
import script from "./Tags.vue?vue&type=script&lang=js&"
export * from "./Tags.vue?vue&type=script&lang=js&"
import style0 from "./Tags.vue?vue&type=style&index=0&id=7d9e4f6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9e4f6c",
  null
  
)

export default component.exports